import React, { useState } from "react";
import { Container, Row, Col, Card, Form, Button, Alert } from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import { useNavigate } from "react-router-dom";
import "../styles/ChangePassword.css";

const ChangePassword = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // Clear messages when user starts typing
    if (error) setError("");
    if (success) setSuccess("");
  };

  // API call function for user change password
 const changePasswordAPI = async (passwordData) => {
  const token = localStorage.getItem('token'); // Get token from localStorage
  
  if (!token) {
    throw new Error('Authentication token not found. Please login again.');
  }

  const apiBaseUrl = process.env.REACT_APP_API_BASE_ROLE || 'http://localhost:7601';
  
  const response = await fetch(`${apiBaseUrl}/user-change-password`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(passwordData)
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Failed to change password');
  }

  return data;
};

  const validateForm = () => {
    // Check if all fields are filled
    if (!formData.currentPassword || !formData.newPassword || !formData.confirmPassword) {
      setError("All fields are required.");
      return false;
    }

    // Check if new password and confirm password match
    if (formData.newPassword !== formData.confirmPassword) {
      setError("New password and confirm password do not match.");
      return false;
    }

    // Check minimum password length
    if (formData.newPassword.length < 6) {
      setError("New password must be at least 6 characters long.");
      return false;
    }

    // Check if new password is different from current password
    if (formData.currentPassword === formData.newPassword) {
      setError("New password must be different from current password.");
      return false;
    }

    // Optional: Check password strength


    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    // Validate form before making API call
    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      const passwordData = {
        currentPassword: formData.currentPassword,
        newPassword: formData.newPassword,
        confirmPassword: formData.confirmPassword,
      };

      const response = await changePasswordAPI(passwordData);
      
      // Success
      setSuccess(response.message || "Password changed successfully!");
      setFormData({ 
        currentPassword: "", 
        newPassword: "", 
        confirmPassword: "" 
      });

      console.log("Password changed successfully:", response);

      // Optional: Show success message for a few seconds then navigate back
      setTimeout(() => {
        navigate(-1);
      }, 2000);

    } catch (error) {
      console.error("Error changing password:", error);
      setError(error.message || "Failed to change password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleMemberLogin = () => {
    navigate("/member-login");
  };

  const handleEdcclogin = () => {
    navigate("/edcc-login");
  };

  return (
    <>
      {/* Hero Section */}
      <section
        className="hero-fixed-change-password"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-content-change-password">
          <h1 className="hero-title">
            All India Occupational Therapists' Association
          </h1>
        </div>
      </section>

      {/* Scrollable Content */}
      <div className="scrollable-content scrollable-content-change-password">
        <div className="content-container change-password-content-container">
          <section className="change-password-section">
            <Container className="mt-5">
              <h2 className="text-center change-password-heading mb-4 pt-4">
                Change Password
              </h2>

              {/* Feedback Messages */}
              {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
              {success && <Alert variant="success" className="mt-3">{success}</Alert>}

              {/* Change Password Form */}
              <Row className="justify-content-center">
                <Col md={6}>
                  <Card className="p-4 shadow-sm change-password-card">
                    <Form onSubmit={handleSubmit}>
                      <Form.Group controlId="currentPassword" className="mb-3">
                        <Form.Label className="form-label-change-password">
                          Current Password *
                        </Form.Label>
                        <Form.Control
                          type="password"
                          name="currentPassword"
                          className="form-control-change-password"
                          value={formData.currentPassword}
                          onChange={handleChange}
                          placeholder="Enter current password"
                          required
                          disabled={loading}
                        />
                      </Form.Group>

                      <Form.Group controlId="newPassword" className="mb-3">
                        <Form.Label className="form-label-change-password">
                          New Password *
                        </Form.Label>
                        <Form.Control
                          type="password"
                          name="newPassword"
                          className="form-control-change-password"
                          value={formData.newPassword}
                          onChange={handleChange}
                          placeholder="Enter new password "
                          required
                          disabled={loading}
                        />
                      </Form.Group>

                      <Form.Group controlId="confirmPassword" className="mb-4">
                        <Form.Label className="form-label-change-password">
                          Confirm New Password *
                        </Form.Label>
                        <Form.Control
                          type="password"
                          name="confirmPassword"
                          className="form-control-change-password"
                          value={formData.confirmPassword}
                          onChange={handleChange}
                          placeholder="Confirm new password"
                          required
                          disabled={loading}
                        />
                      </Form.Group>

                      <div className="d-flex gap-2 justify-content-center">
                        <Button 
                          variant="primary" 
                          type="submit" 
                          className="w-50"
                          disabled={loading}
                        >
                          {loading ? "Changing..." : "Change Password"}
                        </Button>
                        <Button
                          variant="secondary"
                          onClick={() => navigate(-1)}
                          className="w-50"
                          disabled={loading}
                        >
                          Cancel
                        </Button>
                      </div>
                    </Form>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;